var _defs, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrayonIQLogosNegativeSoftwareDownloads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 666.573,
    height: 203.6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect30295",
    d: "M372.155-269.691h579.981v258.092H372.155z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect14471",
    d: "M404.053-143.062H798.1V0H404.053z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect11077",
    d: "M399.22-147.895h383.754v119.863H399.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect30295-2",
    d: "M372.155-269.691h693.077v257.125H372.155z"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st0{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(-.544)"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "Software",
    transform: "translate(-381.04 276.391)",
    id: "text30293",
    style: {
      fontSize: "181.333px",
      lineHeight: 1.25,
      fontFamily: "'Sofia Pro'",
      InkscapeFontSpecification: "'Sofia Pro'",
      letterSpacing: "-10px",
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#rect30295-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.584-147.11c0 19.584 18.314 37.898 43.7 37.898 24.662 0 39.35-14.506 41.707-32.64 2.72-20.128-9.973-33.184-33.365-39.168l-16.32-3.989c-15.776-3.808-17.77-11.968-17.77-17.408 0-11.424 11.06-18.859 23.392-18.859 13.78 0 23.573 7.98 23.573 20.491h16.864c0-22.485-17.59-36.63-40.256-36.63-21.216 0-40.437 14.145-40.437 35.18 0 10.88 3.808 25.93 30.464 32.64l16.138 3.989c11.243 2.538 22.123 8.885 21.216 22.304-1.45 9.429-9.248 18.314-25.205 18.314-15.776 0-26.837-11.242-26.837-22.122z",
    style: {
      fill: "#fff"
    },
    id: "path32784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.463-109.212c24.118 0 44.427-17.589 44.427-44.426 0-26.838-20.31-43.883-44.427-43.883s-44.245 17.045-44.245 43.883c0 26.837 20.128 44.426 44.245 44.426zm0-15.957c-15.413 0-27.925-11.061-27.925-28.47 0-17.045 12.512-27.743 27.925-27.743 15.051 0 27.926 10.698 27.926 27.744 0 17.408-12.875 28.469-27.926 28.469z",
    style: {
      fill: "#fff"
    },
    id: "path32786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.972-241.766h-9.248c-22.848 0-32.458 15.232-32.458 37.536v8.522h-16.32v13.963h16.32v70.72h16.682v-70.72h19.584v-13.963h-19.584v-8.522c0-10.88 1.995-21.76 15.776-21.76h9.248z",
    style: {
      fill: "#fff"
    },
    id: "path32788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.876-195.708v-31.914h-16.501v31.914h-15.232v13.963h15.232v70.72h16.5v-70.72h17.953v-13.963z",
    style: {
      fill: "#fff"
    },
    id: "path32790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m770.798-111.025 31.37-84.683H784.58l-21.216 59.296-21.216-59.296H726.19l-21.216 59.296-21.216-59.296H666.17l32.277 84.683h13.419l22.304-62.197 23.03 62.197z",
    style: {
      fill: "#fff"
    },
    id: "path32792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.038-111.025h16.32v-84.683h-16.32v12.694c-5.803-9.61-17.952-14.507-29.739-14.507-23.21 0-42.976 17.045-42.976 44.064 0 26.837 19.765 44.245 42.976 44.245 11.787 0 24.117-5.44 29.739-14.869zm-.182-42.613c0 17.952-13.056 28.288-28.106 28.288-15.232 0-27.563-11.606-27.563-28.288 0-16.683 12.33-27.744 27.563-27.744 13.781 0 28.106 9.61 28.106 27.744z",
    style: {
      fill: "#fff"
    },
    id: "path32794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.421-141.852c0-22.485 6.891-39.893 23.211-39.893 3.445 0 7.979.725 12.512 2.901l2.539-15.413c-2.358-1.632-8.704-3.264-14.688-3.264-11.062 0-19.222 5.803-23.574 20.853v-19.04h-16.5v84.683h16.5z",
    style: {
      fill: "#fff"
    },
    id: "path32796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.25-159.985c1.995-14.325 12.875-22.667 26.838-22.667 13.78 0 23.754 8.342 25.749 22.667zm68.907 6.347c0-26.838-17.952-43.883-42.07-43.883-24.117 0-43.338 17.045-43.338 43.883 0 26.837 19.221 44.426 43.339 44.426 16.5 0 31.733-7.434 38.986-22.485-4.533-1.995-9.792-3.445-14.144-5.44-4.896 8.523-14.144 13.056-24.299 13.056-14.506 0-25.386-8.704-27.38-23.03h68.724c.182-1.994.182-4.533.182-6.527z",
    style: {
      fill: "#fff"
    },
    id: "path32798"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrayonIQLogosNegativeSoftwareDownloads);
export default __webpack_public_path__ + "static/media/Crayon_iQ_logos_negative_Software_Downloads.92d35cca744ac26b6fb553c95910aa55.svg";
export { ForwardRef as ReactComponent };